import { FC } from 'react';
import { Image as AntdImage } from 'antd';
import { ImagePlaceholder } from './ImagePlaceholder';

type Props = {
  value?: string;
  hyperlink?: string;
};

// Same component for preview/edit/input mode
export const Image: FC<Props> = ({ value, hyperlink }) => {
  if (value) {
    if (hyperlink) {
      return (
        <a href={hyperlink} target="_blank" rel="noreferrer">
          <AntdImage
            data-testid="image-component"
            preview={false}
            src={value}
            style={{
              height: 'auto',
              width: '100%',
              objectFit: 'contain',
              maxHeight: '100%',
              borderRadius: 8,
            }}
          />
        </a>
      );
    }
    return (
      <AntdImage
        data-testid="image-component"
        preview={false}
        src={value}
        style={{
          height: 'auto',
          width: '100%',
          objectFit: 'contain',
          maxHeight: '100%',
          borderRadius: 8,
        }}
      />
    );
  }

  return <ImagePlaceholder />;
};
